import {isRTL} from '../../Localization';

const en = {
    record_already_exist: 'Record already exist in form.',
    ok: 'OK'
};

const he = {
    record_already_exist: 'הרשומה כבר קיימת בטופס',
    ok: 'אישור'
};

export default isRTL() ? he : en;
